import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Navigation } from "../components/Navigation";
import { Hero } from "../components/Hero";
import { Manifesto } from "../components/Manifesto";
import { YachtTeak } from "../components/YachtTeak";
import { HomeCategorySlider } from "../components/HomeCategorySlider";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { setSeo } from "../seo";

export default function Home() {
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    setSeo({
      title: "İnter Orman Ürünleri | Ahşap Kaplama İthalat & İhracat",
      description: "Doğal ve yapay ahşap kaplama, kök kaplama, boyalı kaplama, kereste ve kontrplak. 1983'ten beri ahşap kaplama ithalat ve ihracatı.",
      path: "/",
    });
  }, []);

  useEffect(() => {
    if (!location.state?.scrollTo || !lenis) return;
    const id = location.state.scrollTo;
    let active = true;
    const cancel = () => { active = false; };
    const jump = () => {
      if (!active) return;
      const el = document.getElementById(id);
      if (!el) return;
      const target = Math.round(window.scrollY + el.getBoundingClientRect().top - 80);
      if (Math.abs(window.scrollY - target) > 4) {
        lenis.scrollTo(target, { immediate: true, force: true });
      }
    };
    // Kullanıcı kaydırmaya çalışırsa zorlamayı hemen bırak
    window.addEventListener("wheel", cancel, { passive: true });
    window.addEventListener("touchstart", cancel, { passive: true });
    window.addEventListener("keydown", cancel);
    const iv = setInterval(jump, 150);
    const stop = setTimeout(cancel, 3000);
    return () => {
      clearInterval(iv);
      clearTimeout(stop);
      window.removeEventListener("wheel", cancel);
      window.removeEventListener("touchstart", cancel);
      window.removeEventListener("keydown", cancel);
    };
  }, [location.state, lenis]);

  return (
    <>
      <Navigation />
      <main>
        <Hero />
        <Manifesto />
        <HomeCategorySlider />
        <YachtTeak />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
